import { styled } from '@mui/material/styles'
import Button, { ButtonProps } from '@mui/material/Button'

export interface IButton extends ButtonProps {}

export const ThemedButton = styled(Button)<IButton>(({ theme }) => ({
  boxSizing: 'border-box',
  fontWeight: 500,
  lineHeight: 1,
  textTransform: 'none',
  borderRadius: '0.4rem',
  fontSize: '1.6rem',
  padding: '1.6rem 2.8rem',
  maxHeight: '4.8rem',
  border: '2px solid',
  boxShadow: 'none',
  '&:hover': {
    border: '2px solid',
    boxShadow: 'none',
  },
  '&.MuiButton-sizeSmall': {
    fontSize: '1.4rem',
    padding: '1.2rem 2.0rem',
    maxHeight: '3.8rem',
  },
  '&.MuiButton-sizeMedium': {
    fontSize: '1.6rem',
    padding: '1.6rem 2.8rem',
    maxHeight: '4.8rem',
  },
  '&.MuiButton-containedPrimary': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary[600],
      backgroundColor: 'transparent',
    },
  },
  '&.MuiButton-containedSecondary': {
    borderColor: theme.palette.secondary.main,
    color: theme.palette.primary[600],
    '&:hover': {
      borderColor: theme.palette.secondary.main,
      color: theme.palette.primary[600],
      backgroundColor: 'transparent',
    },
  },
  '&.MuiButton-outlinedPrimary': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary[600],
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
    },
  },
  '&.MuiButton-outlinedSecondary': {
    borderColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary[600],
    },
  },
  '&.MuiButton-text': {
    borderColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary[600],
    },
  },
  '&.Mui-disabled': {
    border: '2px solid',
    backgroundColor: theme.palette.primary[200],
    borderColor: theme.palette.primary[200],
    color: theme.palette.primary[400],
  },
}))
